import { useEffect, useState } from 'react';

const calculateDateDifferenceInSeconds = (date: Date) => Math.floor((date.getTime() - Date.now()) / 1000);

const useCountdown = (endDate: Date) => {
  const [countDown, setCountDown] = useState(calculateDateDifferenceInSeconds(endDate));

  useEffect(() => {
    setCountDown(calculateDateDifferenceInSeconds(endDate));

    const interval = setInterval(() => {
      const newCountDown = calculateDateDifferenceInSeconds(endDate);

      if (newCountDown <= 0) {
        clearInterval(interval);
      }

      setCountDown(calculateDateDifferenceInSeconds(endDate));
    }, 1000);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [endDate]);

  return countDown;
};

export default useCountdown;
